// hooks/useTeamMemberAttendance.js
import { useState, useEffect, useCallback } from "react";
import { getAttendenceStatus } from "api/attendance";
import { formatDateToAPI } from "../utils/timeUtils";

export const useTeamMemberAttendance = (user, dateRange) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [attendanceData, setAttendanceData] = useState({});
  const [timelineData, setTimelineData] = useState([]);

  const fetchTeamMemberData = useCallback(async () => {
    if (!user || !user.id || !dateRange?.start || !dateRange?.end) {
      setAttendanceData({});
      setTimelineData([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const params = {
        from: formatDateToAPI(dateRange.start),
        to: formatDateToAPI(dateRange.end),
        UserId: user.id,
      };
      const response = await getAttendenceStatus(params);
      // Transform the data
      const transformedData = transformAttendanceData(response);
      setAttendanceData(transformedData);

      const timeline = createTimelineData(response.timeline);
      setTimelineData(timeline);
      
    } catch (err) {
      console.error("Error fetching team member attendance:", err);
      setError(err.message || "Failed to fetch team member data");
    } finally {
      setLoading(false);
    }
  }, [user, dateRange]);

  useEffect(() => {
    fetchTeamMemberData();
  }, [fetchTeamMemberData]);

  return { loading, error, attendanceData, timelineData, refresh: fetchTeamMemberData };
};

// Helper function to transform API data
const transformAttendanceData = (apiData) => {
  if (!apiData) return {};
  
  const transformed = {};
  
  if (Array.isArray(apiData)) {
    apiData.forEach((record) => {
      const dateKey = new Date(record.date).toISOString().split('T')[0];
      transformed[dateKey] = record;
    });
  }
  
  return transformed;
};

// Helper function to create timeline data format
// const createTimelineData = (timeline) => {
//   if (!timeline) return [];
  
//   // if (Array.isArray(timeline)) {
//   //   return timeline.map(record => ({
//   //     date: record?.date,
//   //     status: record.status || 'absent',
//   //     status_reason: record.status_reason,
//   //     attendance_status: record.attendance_status || '',
//   //     in: record.in || null,
//   //     out: record.out || null,
//   //     shift_start: record.shift_start || '09:00',
//   //     shift_end: record.shift_end || '18:00',
//   //     worked_minutes: record.worked_minutes,
//   //     type: record.type ,
//   //     breaks: record?.breaks || [],
//   //     shift_name: record.shift_name || 'General'
//   //   }));
//   // }
  

//   if (Array.isArray(timeline)) {
//     return timeline.map(record => ({
//       // 首先添加映射的字段
//       date: record?.date,
//       status: record.status || 'absent',
//       status_reason: record.status_reason,
//       attendance_status: record.attendance_status || '',
//       in: record.in || null,
//       out: record.out || null,
//       shift_start: record.shift_start || '09:00',
//       shift_end: record.shift_end || '18:00',
//       worked_minutes: record.worked_minutes,
//       type: record.type,
//       breaks: record?.breaks || [],
//       shift_name: record.shift_name || 'General',
//       ...record,
//       breaks: record?.breaks || [],
//       shift_name: record.shift_name || 'General'
//     }));
// }
//   return [];
// };

const createTimelineData = (timeline) => {
  if (!Array.isArray(timeline)) return [];

  return timeline
    .map(record => ({
      date: record.date,
      type: "attendance",
      status: record.status,
      status_reason: record.status_reason,
      attendance_status: record.attendance_status,
      in: record.in || null,
      out: record.out || null,
      shift_start: record.shift_start || "09:00",
      shift_end: record.shift_end || "18:00",
      worked_minutes: record.worked_minutes || 0,
      attendance_break_minutes: record.attendance_break_minutes || 0,
      breaks: Array.isArray(record.breaks) ? record.breaks : [],
    }));
};
